<sh-text size="super-header" class="text-align-center">User Management</sh-text>
<div class="container">

<sh-grid columns="12">
    <div columns="1"></div>
    
    <sh-card label="All Users" card-height='250px' columns="4">
            <!-- <sh-search label="Search User" [(ngModel)]="name" (input)="search()" ngDefaultControl></sh-search>  -->
            <sh-input-text id="searchInput" label="Search User" [(ngModel)]="name" (input)="search()" ngDefaultControl></sh-input-text>
            <sh-text id="searchItem" [ngClass]="{'selectedUser':selectedUserIndexArr.includes(i)}" class="cursor-pointer"
                *ngFor="let user of filteredUserList;index as i" (click)="userSelected($event,user.name,i)">{{user.name}} ({{user.userGroup}})</sh-text>

    </sh-card>


        <div columns="2"  label="Select User Group" card-height='250px'>
                <sh-text size="header-1">Select Target Group</sh-text>
                <sh-divider></sh-divider>
                <sh-dropdown id="targetGroup" label='User Group' (value-changed)="selectedUserGroup=$event.target.value" #userGroup>
                        <sh-menu-item id="targetGroupItem" *ngFor="let group of userGroupArr" [label]="group"></sh-menu-item>
                        
                </sh-dropdown>
                <br><br>
              <sh-button class="margin-auto" id="moveBtn" color="Primary" label="Move" (click)="moveUser(userGroup)" 
              [disabled]='selectedUserGroup=="" || selectedUser.length == 0? true : false'></sh-button>
              

            </div>

    <div *ngIf="newListFlag && !invalidUserGroup" columns="4">
            <sh-card  card-height='250px' >
                    <sh-text size="header-1">All {{filteredUserListHeader}} users</sh-text>
                    <sh-divider></sh-divider>
                    <!-- <sh-input-text label="Search User" [(ngModel)]="name" (input)="search()" ngDefaultControl></sh-input-text> -->

                        <sh-text id="updatedUsersListText" class="cursor-pointer"
                            *ngFor="let user of updatedUsersList.sort();index as i" >{{user.name}}</sh-text>
            
                    </sh-card> 
    </div>
     

    <div columns="1"></div>
</sh-grid>
</div>
<sh-modal id="my-modal"
type='error'
label='Not allowed'
modal-height='184px'
modal-width='320px'>
<sh-text >Selected user's user group and the target user group cannot be same.</sh-text>
</sh-modal>
